export default {
    edge_tensor_tab_title: 'Revisiones de Video IA',
    edge_tensor_tab_row_id: 'ID de Fila',
    edge_tensor_tab_status: 'Estado',
    edge_tensor_tab_unit_time: 'Tiempo de Unidad',
    edge_tensor_tab_created_on: 'Creado En',
    edge_tensor_tab_result: 'Resultado',
    edge_tensor_tab_load_error: 'Error de Carga',
    edge_tensor_tab_device_id: 'ID de Dispositivo',
    edge_tensor_tab_status_complete: 'Completado',
    edge_tensor_tab_status_pending: 'Pendiente',
    edge_tensor_tab_status_failed: 'Fallido',
    edge_tensor_tab_raw_message: 'Mensaje Crudo de Revisión de Video IA',
    edge_tensor_tab_data: 'Datos',
    edge_tensor_tab_response: 'Respuesta',
    edge_tensor_tab_process_time: 'Tiempo de Proceso',
    edge_tensor_tab_result_events: 'Eventos de Resultado',
    edge_tensor_tab_results: 'Resultados',
    edge_tensor_tab_event_name: 'Nombre del Evento',
    edge_tensor_tab_event_review: 'Revisión del Evento',
    edge_tensor_tab_device: 'Dispositivo',
    edge_tensor_tab_account: 'Cuenta',
    edge_tensor_tab_date_range: 'Rango de Fechas',
    edge_tensor_tab_review_status: 'Estado de Revisión',  
    edge_tensor_tab_open_video: 'Abrir Video',
    edge_tensor_no_events: 'No Hay Eventos',
    edge_tensor_tab_video_url: 'URL del Video',
    edge_tensor_tab_confirm: 'Confirmar',
    edge_tensor_tab_unknown: 'Desconocido',
    edge_tensor_tab_false_positive: 'Falso Positivo',
    edge_tensor_tab_unreviewed: 'No Revisado'
}
